import { render, staticRenderFns } from "./ProjectFilesMatchedTableSmall.vue?vue&type=template&id=417ade34"
import script from "./ProjectFilesMatchedTableSmall.vue?vue&type=script&lang=ts"
export * from "./ProjectFilesMatchedTableSmall.vue?vue&type=script&lang=ts"
import style0 from "./ProjectFilesMatchedTableSmall.vue?vue&type=style&index=0&id=417ade34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports